import { GetCustomerSupplierMappingsOutput, GetPaymentMethodResponse } from '@/ar/network/AccountsReceivable.network';
import { SIGN_UP_SUPPLIER_ID_KEY } from '@/ar/pages/SignUpPage/CustomerSignUpPage';
import { SupplierLoginData } from '@/ar/stores/SupplierStore';

/**
 * Retrieves the supplier ID based off supplier login data
 *
 * @param supplierLoginData supplier login data retrieved from supplier store
 * @param supplierMappingData supplier mapping data based off customer
 * @returns Supplier ID
 */

export const getSupplierID = (supplierLoginData: SupplierLoginData, supplierMappingData: GetCustomerSupplierMappingsOutput): string => {
    const supplierID = supplierLoginData.supplier_id ?? window.localStorage.getItem(SIGN_UP_SUPPLIER_ID_KEY) ?? supplierMappingData?.suppliers[0]?.id;
    return supplierID;
};

export const isPaymentMethodForSupplier = (paymentMethod: GetPaymentMethodResponse, supplierId: string, gpoId: string | null): boolean => paymentMethod?.mandate_supplier_id === supplierId // bank accounts mandated for supplier
    || paymentMethod?.mandate_id === null // card payment methods
    || paymentMethod?.mandate_id.startsWith('mandate_') // Stripe bank accounts
    || (gpoId !== null && paymentMethod?.mandate_gpo_id === gpoId); // bank accounts mandated for GPO if supplier is in GPO

export const isPaymentMethodForAllSuppliers = (paymentMethod: GetPaymentMethodResponse, supplierIds: string[], gpoId: string | null): boolean => supplierIds.every((supplierId) => isPaymentMethodForSupplier(paymentMethod, supplierId, gpoId));
